// extracted by mini-css-extract-plugin
export default {"cellHasError":"dWoKSKt7YewI5lpA9LQCH"};